export enum BusinessHealthCoverageWaitingDelay {
  ZERO_DAYS = 'ZERO_DAYS',
  SEVEN_DAYS = 'SEVEN_DAYS',
  FOURTEEN_DAYS = 'FOURTEEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  SIXTY_DAYS = 'SIXTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS',
}

export const BUSINESS_HEALTH_COVERAGE_WAITING_DELAY_VALUES = Object.values(
  BusinessHealthCoverageWaitingDelay
);

export const getBusinessHealthCoverageWaitingDelayLabel = (
  value: BusinessHealthCoverageWaitingDelay
) => {
  switch (value) {
    case BusinessHealthCoverageWaitingDelay.ZERO_DAYS:
      return $localize`0 jour`;
    case BusinessHealthCoverageWaitingDelay.SEVEN_DAYS:
      return $localize`7 jours`;
    case BusinessHealthCoverageWaitingDelay.FOURTEEN_DAYS:
      return $localize`14 jours`;
    case BusinessHealthCoverageWaitingDelay.THIRTY_DAYS:
      return $localize`30 jours`;
    case BusinessHealthCoverageWaitingDelay.SIXTY_DAYS:
      return $localize`60 jours`;
    case BusinessHealthCoverageWaitingDelay.NINETY_DAYS:
      return $localize`90 jours`;
  }
};
